/**
 * Comunicação do veículo por fonte (Merus × Geotab × FaceID), a partir de
 * getstatuscomunicacaoequipamentosporveiculo. Usada no resumo do filtro por veículo e no
 * detalhe do validador.
 */
export function resumoComunicacao(rows) {
  const lista = Array.isArray(rows) ? rows : [];
  const geotab = lista.find((r) => r.fonte === 'GEOTAB') || null;
  const faceid = lista.find((r) => r.fonte === 'FACEID') || null;
  const qualquer = lista[0] || null;
  const merusOffline = qualquer != null ? Number(qualquer.gps_offline_merus) === 1 : null;
  const statusGeotab = geotab ? geotab.status_na_fonte : null;
  return {
    merusOffline,
    dtMerus: qualquer ? qualquer.dt_ultima_posicao_merus : null,
    statusGeotab,
    dtGeotab: geotab ? geotab.dt_ultima_comunicacao_fonte : null,
    temGeotab: !!geotab,
    statusFaceid: faceid ? faceid.status_na_fonte : null,
    dtFaceid: faceid ? faceid.dt_ultima_comunicacao_fonte : null,
    temFaceid: !!faceid,
    // Merus sem posição enquanto o Geotab diz que o veículo está comunicando.
    divergencia: merusOffline === true && geotab != null && Number(statusGeotab) === 1,
  };
}

export default {
  methods: {
    fmtMerus(offline) {
      if (offline == null) return this.$t('statusDispositivos.vehicleComm.na');
      return offline
        ? this.$t('statusDispositivos.commStatus.offline')
        : this.$t('statusDispositivos.commStatus.online');
    },
    corMerus(offline) {
      if (offline == null) return 'grey';
      return offline ? 'red' : 'green';
    },
    iconeMerus(offline) {
      if (offline == null) return 'mdi-help-circle';
      return offline ? 'mdi-close-circle' : 'mdi-check-circle';
    },
    fmtGeotab(valor) {
      if (valor == null || valor === '') return this.$t('statusDispositivos.vehicleComm.noEquipment');
      if (Number(valor) === 1) return this.$t('statusDispositivos.commStatus.online');
      if (Number(valor) === 0) return this.$t('statusDispositivos.commStatus.offline');
      return this.$t('statusDispositivos.vehicleComm.na');
    },
    corGeotab(valor) {
      if (Number(valor) === 1) return 'green';
      if (valor != null && valor !== '' && Number(valor) === 0) return 'red';
      return 'grey';
    },
    iconeGeotab(valor) {
      if (Number(valor) === 1) return 'mdi-check-circle';
      if (valor != null && valor !== '' && Number(valor) === 0) return 'mdi-close-circle';
      return 'mdi-help-circle';
    },
    fmtStatusComunicacaoOuNa(valor, temEquipamento) {
      if (!temEquipamento) return this.$t('statusDispositivos.vehicleComm.noEquipment');
      return this.fmtStatusComunicacao(valor);
    },
  },
};
